module.exports = __webpack_public_path__ + "static/media/41.b3b086b8.png";